<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table [value]="fields" [loading]="loading" styleClass="p-datatable-striped"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true"
  [paginator]="true" [rows]="100" [rowsPerPageOptions]="[100,500]">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between">
      <span style="font-size: 1.2rem; font-weight: 600;">Quality Test Field Registry</span>
      <button pButton pRipple class="p-button" icon="pi pi-plus" label="Add Field"
        style="padding: 0.643rem 0.75rem !important;"
        (click)="openAddDialog()"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>Field Key</th>
      <th>Display Name</th>
      <th>Data Type</th>
      <th>Data Source</th>
      <th>Java Path</th>
      <th>Allowed Operators</th>
      <th>Active</th>
      <th style="width:80px;"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-field>
    <tr>
      <td><strong>{{field.fieldKey}}</strong></td>
      <td>{{field.displayName}}</td>
      <td>{{field.dataType}}</td>
      <td>{{field.dataSource}}</td>
      <td><code style="font-size:0.8rem;">{{field.javaPath}}</code></td>
      <td>{{field.allowedOperators}}</td>
      <td>
        <i class="pi" [ngClass]="field.isActive === 1 ? 'pi-check-circle' : 'pi-times-circle'"
          [style.color]="field.isActive === 1 ? '#22c55e' : '#ef4444'"></i>
      </td>
      <td>
        <i class="pi pi-pencil" style="color:blue; font-size:110%; padding-right:12px; cursor:pointer;"
          (click)="openEditDialog(field)"></i>
        <i class="pi pi-trash" style="color:#ef4444; font-size:110%; cursor:pointer;"
          (click)="onDeleteField(field)"></i>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr><td colspan="8">No fields registered.</td></tr>
  </ng-template>
</p-table>

<!-- Inline edit dialog -->
<p-dialog header="Field Registry" [(visible)]="showEditDialog" [modal]="true"
  [style]="{width:'600px'}" [draggable]="false" [resizable]="false" appendTo="body">

  <div [formGroup]="editForm" class="p-fluid p-formgrid p-grid">

    <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
      <label>Field Key</label>
      <input pInputText formControlName="fieldKey" />
    </div>
    <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
      <label>Display Name</label>
      <input pInputText formControlName="displayName" />
    </div>
    <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
      <label>Data Type</label>
      <input pInputText formControlName="dataType" placeholder="String, Integer, Boolean..." />
    </div>
    <div class="p-field p-col-12 p-md-6" style="margin-bottom:12px;">
      <label>Data Source</label>
      <input pInputText formControlName="dataSource" placeholder="ShortTermRentalVO, etc." />
    </div>
    <div class="p-field p-col-12" style="margin-bottom:12px;">
      <label>Java Path</label>
      <input pInputText formControlName="javaPath" placeholder="e.g. shortTermRentalVO.pictureList.size()" />
    </div>
    <div class="p-field p-col-12" style="margin-bottom:12px;">
      <label>Allowed Operators</label>
      <input pInputText formControlName="allowedOperators" placeholder="GTE,LTE,EQ,NOT_NULL" />
    </div>
    <div class="p-field p-col-12" style="margin-bottom:12px;">
      <label>Aliases</label>
      <input pInputText formControlName="aliases" placeholder="Comma-separated alias names" />
    </div>
    <div class="p-field p-col-12" style="margin-bottom:12px;">
      <label>Description</label>
      <textarea pInputTextarea formControlName="description" rows="2"></textarea>
    </div>
    <div class="p-field p-col-12" style="margin-bottom:12px; display:flex; align-items:center; gap:8px;">
      <p-checkbox formControlName="isActive" [binary]="true" [trueValue]="1" [falseValue]="0"
        inputId="fieldIsActive"></p-checkbox>
      <label for="fieldIsActive" style="margin:0;">Active</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" class="p-button-outlined"
      (click)="showEditDialog=false" [disabled]="formLoading"></button>
    <button pButton pRipple label="Save" icon="pi pi-save"
      (click)="onSaveField()" [disabled]="formLoading"></button>
  </ng-template>
</p-dialog>
